/* eslint-disable no-nested-ternary */
// TODO: refactor this module to meet 'no-nested-ternary' rule
import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Select from '../shared/Select';
import i18n from '../../config/i18n';

class MedicationRow extends Component {
  constructor(props) {
    super(props);

    const {
      medication,
      medicationId,
    } = this.props;
    this.state = {
      medication: medication ? medication.medication : '',
      frequencyA: medication ? medication.frequencyA : '',
      frequencyB: medication ? medication.frequencyB : '',
      dosage: medication ? medication.dosage : '',
      medicationId,
    };

    this.handleMedicationChange = this.handleMedicationChange.bind(this);
    this.handleFrequencyAChange = this.handleFrequencyAChange.bind(this);
    this.handleFrequencyBChange = this.handleFrequencyBChange.bind(this);
    this.handleDosageChange = this.handleDosageChange.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
  }

  handleMedicationChange(value) {
    const { onChangeMedications } = this.props;
    this.setState({ medication: value });
    onChangeMedications.call(this, value, this.state.medicationId);
  }

  handleFrequencyAChange(value) {
    const { onChangeFrequencyA } = this.props;
    this.setState({ frequencyA: value });
    onChangeFrequencyA.call(this, value, this.state.medicationId);
  }

  handleFrequencyBChange(value) {
    const { onChangeFrequencyB } = this.props;
    this.setState({ frequencyB: value });
    onChangeFrequencyB.call(this, value, this.state.medicationId);
  }

  handleDosageChange(e) {
    const { onChangeDosage } = this.props;
    onChangeDosage.call(this, e.target.value, this.state.medicationId);
  }

  deleteRow() {
    const { onClickDelete } = this.props;
    // eslint-disable-next-line no-alert
    if (window.confirm(i18n.t('clickHereToDeleteMsg'))) {
      onClickDelete.call(this, this.state.medicationId);
    }
  }

  render() {
    const {
      metadata,
      isEditing,
      medication: {
        dosage,
      },
    } = this.props;
    const medication = _.filter(metadata.data.medication,
      { id: parseInt(this.state.medication, 10) });
    const frequencyA = _.filter(metadata.data.dressingChangeFrequencyA,
      { id: parseInt(this.state.frequencyA, 10) });
    const frequencyB = _.filter(metadata.data.dressingChangeFrequencyB,
      { id: parseInt(this.state.frequencyB, 10) });

    return (
      <tr>
        <td>
          {
            isEditing ? (
              <Select
                className="form-control"
                data={metadata.data.medication || []}
                onChange={this.handleMedicationChange}
                value={this.state.medication}
              />
            ) : (
              medication[0] ? medication[0].name : ''
            )
          }
        </td>
        <td>
          {
            isEditing ? (
              <Select
                className="form-control"
                data={metadata.data.dressingChangeFrequencyA || []}
                onChange={this.handleFrequencyAChange}
                value={this.state.frequencyA}
              />
            ) : (
              frequencyA[0] ? frequencyA[0].name : ''
            )
          }
        </td>
        <td>
          {
            isEditing ? (
              <Select
                className="form-control"
                data={metadata.data.dressingChangeFrequencyB || []}
                onChange={this.handleFrequencyBChange}
                value={this.state.frequencyB}
              />
            ) : (
              frequencyB[0] ? frequencyB[0].name : ''
            )
          }
        </td>
        {
          isEditing ? (
            <td className="input-group">
              <input
                className="form-control"
                type="text"
                value={dosage || ''}
                onChange={this.handleDosageChange}
              />
              <span className="input-group-btn">
                <button
                  className="btn btn-danger btn-sm"
                  style={{ marginLeft: 10 }}
                  onClick={this.deleteRow}
                >
                  x
                </button>
              </span>
            </td>
          ) : (
            <td>{dosage}</td>
          )
        }
      </tr>
    );
  }
}

MedicationRow.propTypes = {
  onChangeDosage: PropTypes.func,
  onChangeFrequencyA: PropTypes.func,
  onChangeFrequencyB: PropTypes.func,
  onChangeMedications: PropTypes.func,
  onClickDelete: PropTypes.func,
};

MedicationRow.defaultProps = {
  onChangeDosage: () => {},
  onChangeFrequencyA: () => {},
  onChangeFrequencyB: () => {},
  onChangeMedications: () => {},
  onClickDelete: () => {},
};

export default MedicationRow;



// WEBPACK FOOTER //
// ./src/components/patient/MedicationRow.js